import { graphql } from '@/gql';

export const SubmitPerformanceFinSwimResultMutation = graphql(`
    mutation SubmitPerformanceFinSwimResult($input: SubmitFinSwimResultInput!) {
        submitFinSwimResult(input: $input) {
            ... on SubmitFinSwimResultSuccessfulResponse {
                result {
                    ...FinSwimPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const _FinSwimPerformanceResult = graphql(`
    fragment FinSwimPerformanceResult on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on FinSwimResult {
                ...FinSwimPerformanceResultData
            }
        }
        createdAt
        completedAt
        updatedAt
        updatedBy
        isDeleted
    }
`);

const _FinSwimPerformanceResultData = graphql(`
    fragment FinSwimPerformanceResultData on FinSwimResult {
        timingSec
    }
`);
